import { render } from "./Attach.vue?vue&type=template&id=38ea3772"
import script from "./Attach.vue?vue&type=script&lang=js"
export * from "./Attach.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__